import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../core/base.service';

@Injectable({
  providedIn: 'root'
})
export class InvestmentNovaPoliciesService {
  constructor(private http: HttpClient, private base: BaseService) {}

  getInvestmentNovaPolicyToken(policyNumber: string): Observable<string> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/pensionInvestmentPolicies/${policyNumber}/nova/tokenUrl`;
    return this.http.get<string>(
      url,
      this.base.getPrivateOIMHeaders({ cacheResponse: true })
    );
  }
}
